import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;

  height: 32px;
  border-radius: 8px;
  background-color: ${ColorPalette.HEX.Seashell};
  padding: 12px;
`;

export const Icon = styled.img`
  width: 16px;
  height: 16px;
  margin-right: 8px;
`;

export const Label = styled.span`
  font-size: 16px;
  line-height: 1.5;
  color: ${ColorPalette.HEX.RedRYB};
`;
